import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  label: 'Program de Grup',
  href: 'https://psihomedicina.ro/start'
}, {
  label: 'Cursuri Online',
  href: 'https://psihomedicina.ro/fitoterapie'
}, {
  label: 'Sesiune Cadou',
  href: 'https://api.leadconnectorhq.com/widget/bookings/cmi-dr-cornelia-tianu-39b19d4e-46bc-4f77-b746-6d1dddacfb09'
}, {
  label: 'Despre Mine',
  href: 'https://psihomedicina.ro/despre'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  return <nav className="bg-white/90 backdrop-blur-md fixed top-0 left-0 right-0 z-50 border-b border-soft/50 shadow-sm" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="flex items-center justify-between h-16" data-id="element-168">
          {/* Logo */}
          <a href="https://psihomedicina.ro/" className="flex items-center" data-id="element-169">
            <img src="https://cdn.magicpatterns.com/uploads/uHbK1QXv8cqZk8wKkAy8Rh/Screenshot_2026-04-19_at_00.13.33.png" alt="Academia de PsihoMedicină" className="h-12 object-contain" data-id="element-170" />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6" data-id="element-171">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-body hover:text-primary transition-colors text-sm font-medium" data-id="element-172">
                {link.label}
              </a>)}
            <a href="https://psihomedicina.app.clientclub.net/courses/library-v2" className="bg-primary text-white font-semibold rounded-full px-5 py-2 text-sm hover:bg-medium transition-colors shadow-md" data-id="element-173">
              Autentificare
            </a>
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setOpen(!open)} className="md:hidden p-2 text-body hover:text-primary transition-colors" aria-label="Toggle menu" data-id="element-174">
            {open ? <X className="w-6 h-6" data-id="element-175" /> : <Menu className="w-6 h-6" data-id="element-176" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && <div className="md:hidden bg-white border-t border-soft/50 px-4 pb-4 relative z-[60]" data-id="element-177">
          <div className="flex flex-col gap-3 pt-3" data-id="element-178">
            {navLinks.map(link => <a key={link.label} href={link.href} className="block text-body hover:text-primary transition-colors font-medium py-3 px-2" data-id="element-179">
                {link.label}
              </a>)}
            <a href="https://psihomedicina.app.clientclub.net/courses/library-v2" className="block bg-primary text-white font-semibold rounded-full px-5 py-3 text-center hover:bg-medium transition-colors shadow-md mt-2" data-id="element-180">
              Autentificare
            </a>
          </div>
        </div>}
    </nav>;
}